module.exports = __webpack_public_path__ + "media/images/lb/222-fa016b6d5c60343c76ddc718ae5161e5.svg";